import { keyframes, styled } from "styled-components";
import { hexWithOpacity } from "../../utils/hexWithOpacity";

type Props = {
  className?: string;
  hasShadow?: boolean;
  height?: string | number;
  width?: string | number;
  borderRadius?: string | number;
  count?: number;
};
export const SkeletonPlaceholder = ({
  className,
  hasShadow,
  height,
  width,
  borderRadius,
  count,
}: Props) => {
  return (
    <>
      {count && count > 1 ? (
        Array.from({ length: count }).map((_, index) => (
          <SkeletonPlaceholderComponent
            key={index}
            className={className}
            $hasShadow={hasShadow}
            $height={height}
            $width={width}
            $borderRadius={borderRadius}
          />
        ))
      ) : (
        <SkeletonPlaceholderComponent
          className={className}
          $hasShadow={hasShadow}
          $height={height}
          $width={width}
          $borderRadius={borderRadius}
        />
      )}
    </>
  );
};

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const SkeletonPlaceholderComponent = styled.div<{
  $hasShadow?: boolean;
  $height?: string | number;
  $width?: string | number;
  $borderRadius?: string | number;
}>`
  box-shadow: ${(props) =>
    props.$hasShadow ? "2px 2px 8px rgba(0, 0, 0, 0.25)" : "none"};
  background: linear-gradient(
    90deg,
    ${({ theme }) => hexWithOpacity(theme.colors.light, 0.5)} 25%,
    ${({ theme }) => hexWithOpacity(theme.colors.medium, 0.3)} 37%,
    ${({ theme }) => hexWithOpacity(theme.colors.light, 0.5)} 63%
  );
  background-size: 400% 100%;
  animation: ${shimmer} 3s ease-in-out infinite;
  height: ${(props) =>
    props.$height
      ? typeof props.$height === "number"
        ? `${props.$height}px`
        : props.$height
      : "100%"};
  width: ${(props) =>
    props.$width
      ? typeof props.$width === "number"
        ? `${props.$width}px`
        : props.$width
      : "100%"};
  border-radius: ${(props) =>
    props.$borderRadius
      ? typeof props.$borderRadius === "number"
        ? `${props.$borderRadius}px`
        : props.$borderRadius
      : "4px"};
`;
